import { MouseEvent, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { addBetSlipEvent, removeBetSlipEvent } from 'utils/betslip/betslip';
import {
  Event as EventType,
  GameOnly,
  TPossibleMarkets
} from 'interfaces/sportsbook-data-levels';
import { getSubscriptions } from 'store/selectors/betslip';

// type TPossibleMarkets = MarketOnly | Market;

type THandler = (
  e: MouseEvent<HTMLElement> | undefined,
  game: GameOnly,
  event: EventType,
  competitionName: string,
  markets: Record<string, TPossibleMarkets> | TPossibleMarkets[],
  sportAlias: string,
  isUsa?: boolean
) => void;

export const useHandleOddSelect = (
  sportId: number
): { handleOddSelect: THandler } => {
  // TODO can be changed to useSelector(getEventIds)
  const subscriptions = useSelector(getSubscriptions);
  const selectedEventIds = useMemo(
    () =>
      subscriptions.map(subscription => {
        return subscription.eventId;
      }),
    [subscriptions]
  );

  const handleOddSelect = useCallback(
    (
      e: MouseEvent<HTMLElement> | undefined,
      game: GameOnly,
      event: EventType,
      competitionName: string,
      markets: Record<string, TPossibleMarkets> | TPossibleMarkets[],
      sportAlias: string,
      isUsa?: boolean
    ) => {
      e?.stopPropagation();

      if (game.is_blocked) {
        return;
      }

      const market = Object.values(markets)[0];

      if (!selectedEventIds.includes(event.id)) {
        const betSlipObject = {
          sport_id: sportId,
          sport_index: sportAlias as string | undefined,
          sport_alias: sportAlias as string,
          competition_name: competitionName,
          current_game_state: game.info?.current_game_state || '',
          current_game_time: game.info?.current_game_time,
          isLive: !!game.is_live,
          region_name: game.region_alias as string,
          game_start_date: game.start_ts,
          market_name: market.name,
          marketType: market.type || '',
          gameId: game.id,
          eventId: event.id,
          event_name: event.name,
          coeficient: event.price,
          eventBase: event.base,
          team1: game.team1_name,
          team2: game.team2_name,
          isSuspended: false,
          game_name:
            game.team2_name && game.team2_name.length
              ? `${game.team1_name}-${game.team2_name}`
              : game.team1_name,
          game_state: game.info?.current_game_state || '',
          type: game.type,
          game_info: game.info,
          express_id: market.express_id,
          type_1: event.type_1,
          isUsa: isUsa
        };

        addBetSlipEvent(betSlipObject, false, true);
      } else {
        removeBetSlipEvent(event.id);
      }
    },
    [selectedEventIds]
  );

  return {
    handleOddSelect
  };
};
